// extracted by mini-css-extract-plugin
module.exports = {"root":"animateButton_root__WuKjC","animateButton":"animateButton_animateButton__NxTBh","templateCtbcGreen":"animateButton_templateCtbcGreen__1fMFC"};